<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-panel header="{{ 'METAVENTASEGURO.LBL_METAVENTA' | translate}}">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">
          <div class="grid">
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'METAVENTASEGURO.LBL_VALORMINIMOPRIMA' | translate }}</label>
                <input type="text" pInputText id="valor" name="nomValor" autocomplete="off"
                  formControlName="valorMinimoPrima" [maxlength]="18" currencyMask
                  [options]="{ prefix: '$ ', thousands: appSettingService.separadorMiles, decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 0 }">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.valorMinimoPrima.invalid">
                  {{ 'METAVENTASEGURO.LBL_VALORMINIMOPRIMA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-6 lg:col-6">
              <div class="div-form">
                <label>* {{ 'METAVENTASEGURO.LBL_MINIMOPOLIZAUNIDAD' | translate }}</label>
                <input type="text" pInputText id="minPoliza" name="nomMinPoliza" autocomplete="off"
                  formControlName="numeroPolizaUnidadCredito" numero-entero-reactive [maxlength]="5">
                <div class="p-message p-messages-error p-corner-all"
                  *ngIf="submitted && f.numeroPolizaUnidadCredito.invalid">
                  {{ 'METAVENTASEGURO.LBL_MINIMOPOLIZAUNIDAD' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-12 lg:col-12">
              <div class="div-form">
                <label>{{ 'METAVENTASEGURO.LBL_DESCRIPCION' | translate }}</label>
                <textarea id="descripcion" name="descripcion" pInputTextarea rows="2"
                 maxlength="50" formControlName="descripcion"></textarea>
              </div>
            </div>
          </div>
          <div class="grid">
            <div class="col-12 md:col-2 p-lg2">
              <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true" id="indicadorHabilitado"
                name="nomIndicador" formControlName="indicadorHabilitado"></p-checkbox>
            </div>
            <div class="col-12 md:col-1 lg:col-1">
              <button type="button" class="p-button btn" icon="fa fa-info" data-toggle="tooltip"
                title="{{'FLUJOPROCESOFERTA.BTN_INFO' | translate}}" (click)="verInfo(toggleInfo, $event)"
                pButton></button>
            </div>

          </div>
          <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}" type="submit" pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </p-panel>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button" pButton
            (click)="regresar(false)"></button>
        </div>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
<p-overlayPanel #toggleInfo appendTo="body">
  <div class="div-contenedor">
    <div class="div-toogle">
      <div>
        <p>{{mensajeTooltip}}</p>
      </div>
    </div>
  </div>
</p-overlayPanel>
